var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share d-center",on:{"click":_vm.click}},[_c('base-icon',[_vm._v(_vm._s(_vm.outline ? "sci-share-outline" : "sci-share"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }